import { UIActionButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { updateTopicPinnedKnowledge } from "domains/pinAddReject/actions";
import {
  checkArePinningTopicsPending,
  checkIsKnowledgePinnedForTopic,
  getIsPinPending,
} from "domains/pinAddReject/selectors";
import type { KnowledgeType } from "entities/knowledge/types";
import { createCanEditTopicSelector } from "entities/topics/selectors";

type KnowledgeDetailPinButtonProps = {
  topicId: string;
  knowledgeId: string;
  knowledgeType: KnowledgeType;
  hideButtonLabels?: boolean;
};

export const KnowledgeDetailPinButton = ({
  topicId,
  knowledgeId,
  knowledgeType,
  hideButtonLabels,
}: KnowledgeDetailPinButtonProps) => {
  const dispatch = useDispatch();
  const canEditTopic = useSelector(createCanEditTopicSelector(topicId));
  const isPinUpdatePending = useSelector(getIsPinPending(knowledgeId));

  const doesTopicPinKnowledge = useSelector(checkIsKnowledgePinnedForTopic(knowledgeId, topicId));
  const arePinningTopicsPending = useSelector(checkArePinningTopicsPending(knowledgeId));

  const isLoading = arePinningTopicsPending || isPinUpdatePending;

  const updatePinState = (event: React.MouseEvent) => {
    event.stopPropagation();

    dispatch(
      updateTopicPinnedKnowledge({
        topicId,
        knowledgeId,
        isPinned: doesTopicPinKnowledge,
        knowledgeType,
      }),
    );
  };

  if (!canEditTopic) return null;

  return (
    <UIActionButton
      type={doesTopicPinKnowledge ? "unpin" : "pin"}
      onClick={updatePinState}
      isLoading={isLoading}
      hideLabel={hideButtonLabels}
    />
  );
};
